import React, { useState } from 'react';
import baseStyles from "./styles.module.css.js";
import useStyleOverride from "../../hooks/useStyleOverride.js";
import useComponentOverride from "../../hooks/useComponentOverride.js";
export var ResultGroup = _ref => {
  var {
    allowCollapse = true,
    onResultClick,
    groupProps,
    results
  } = _ref;
  var styles = useStyleOverride('results/ResultGroup', baseStyles);
  var [GroupHeader, ResultItem] = useComponentOverride('results/GroupHeader', 'results/ResultItem');
  var [isCollapsed, setIsCollapsed] = useState(false);
  return /*#__PURE__*/React.createElement("div", {
    className: styles.ResultGroup
  }, /*#__PURE__*/React.createElement(GroupHeader, {
    groupProps: groupProps,
    isCollapsed: isCollapsed,
    toggleCollapse: allowCollapse ? () => setIsCollapsed(!isCollapsed) : undefined,
    results: results
  }), !isCollapsed && /*#__PURE__*/React.createElement("div", {
    className: styles.ResultsContainer
  }, results.map((result, i) => /*#__PURE__*/React.createElement(ResultItem, {
    result: result,
    key: i,
    onClick: onResultClick ? e => onResultClick(result, e) : undefined
  }))));
};
export default ResultGroup;
//# sourceMappingURL=index.js.map